var _g, _mask, _path, _path2, _path3, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWaitingPointMarker = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1753_180916)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 29,
    rx: 4,
    ry: 2,
    fill: "black",
    fillOpacity: 0.12
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1753_180916",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 22,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5,
    y: 1,
    width: 22,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9159 20.0632C24.3926 18.243 26 15.3092 26 12C26 6.47715 21.5228 2 16 2C10.4772 2 6 6.47715 6 12C6 15.3092 7.60742 18.243 10.0841 20.0632C11.9661 21.4813 14.619 23.7185 15.2288 27.3195C15.2934 27.701 15.6131 27.997 16 27.997C16.3869 27.997 16.7066 27.701 16.7712 27.3195C17.381 23.7185 20.0339 21.4813 21.9159 20.0632Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9159 20.0632C24.3926 18.243 26 15.3092 26 12C26 6.47715 21.5228 2 16 2C10.4772 2 6 6.47715 6 12C6 15.3092 7.60742 18.243 10.0841 20.0632C11.9661 21.4813 14.619 23.7185 15.2288 27.3195C15.2934 27.701 15.6131 27.997 16 27.997C16.3869 27.997 16.7066 27.701 16.7712 27.3195C17.381 23.7185 20.0339 21.4813 21.9159 20.0632Z",
    fill: "#FEC514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9159 20.0632L21.3237 19.2573L21.3141 19.2645L21.9159 20.0632ZM10.0841 20.0632L10.6859 19.2645L10.6763 19.2574L10.0841 20.0632ZM15.2288 27.3195L14.2428 27.4865H14.2428L15.2288 27.3195ZM16.7712 27.3195L17.7572 27.4865H17.7572L16.7712 27.3195ZM22.5081 20.869C25.2301 18.8685 27 15.6409 27 12H25C25 14.9776 23.555 17.6175 21.3237 19.2574L22.5081 20.869ZM27 12C27 5.92487 22.0751 1 16 1V3C20.9706 3 25 7.02944 25 12H27ZM16 1C9.92487 1 5 5.92487 5 12H7C7 7.02944 11.0294 3 16 3V1ZM5 12C5 15.6409 6.76987 18.8685 9.49185 20.869L10.6763 19.2574C8.44496 17.6175 7 14.9776 7 12H5ZM16.2147 27.1526C15.5345 23.1359 12.5819 20.6933 10.6859 19.2645L9.48226 20.8618C11.3502 22.2694 13.7034 24.3011 14.2428 27.4865L16.2147 27.1526ZM16 26.997C16.0686 26.997 16.1251 27.0246 16.1593 27.0551C16.1912 27.0836 16.2089 27.118 16.2147 27.1526L14.2428 27.4865C14.3809 28.3017 15.0789 28.997 16 28.997V26.997ZM15.7853 27.1526C15.7911 27.118 15.8088 27.0836 15.8407 27.0551C15.8749 27.0246 15.9314 26.997 16 26.997V28.997C16.9211 28.997 17.6191 28.3017 17.7572 27.4865L15.7853 27.1526ZM21.3141 19.2645C19.4181 20.6933 16.4655 23.1359 15.7853 27.1526L17.7572 27.4865C18.2966 24.3011 20.6498 22.2694 22.5177 20.8618L21.3141 19.2645Z",
    fill: "#FAFEFF",
    fillOpacity: 0.5,
    mask: "url(#path-2-outside-1_1753_180916)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4445 7.75V6.75H17.5556V7.75H14.4445ZM15.4815 13.25H16.5186V10.25H15.4815V13.25ZM16 17.25C15.3605 17.25 14.7578 17.1313 14.1917 16.8938C13.6257 16.6562 13.1309 16.3333 12.7074 15.925C12.284 15.5167 11.9491 15.0396 11.7028 14.4938C11.4565 13.9479 11.3334 13.3667 11.3334 12.75C11.3334 12.1333 11.4565 11.5521 11.7028 11.0063C11.9491 10.4604 12.284 9.98333 12.7074 9.575C13.1309 9.16667 13.6257 8.84375 14.1917 8.60625C14.7578 8.36875 15.3605 8.25 16 8.25C16.5358 8.25 17.05 8.33333 17.5426 8.5C18.0352 8.66667 18.4976 8.90833 18.9297 9.225L19.6556 8.525L20.3815 9.225L19.6556 9.925C19.984 10.3417 20.2346 10.7875 20.4074 11.2625C20.5803 11.7375 20.6667 12.2333 20.6667 12.75C20.6667 13.3667 20.5436 13.9479 20.2973 14.4938C20.051 15.0396 19.7161 15.5167 19.2926 15.925C18.8692 16.3333 18.3744 16.6562 17.8084 16.8938C17.2423 17.1313 16.6395 17.25 16 17.25Z",
    fill: "#000405"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1753_180916",
    x: 10,
    y: 25,
    width: 12,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1753_180916"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaitingPointMarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/WaitingPointMarker.63b56971.svg";
export { ForwardRef as ReactComponent };